<template>
  <el-dialog
    v-dialogDrag
    width="1280px"
    class="large-dialog"
    @close="closeDialog"
    :title="
      formProps.pageType === 'create'
        ? '新增'
        : formProps.pageType === 'update'
        ? '编辑'
        : '查看' + '风险分析单元'
    "
    :visible.sync="visible"
    :close-on-click-modal="false"
  >
    <div>
      <el-form ref="form" label-width="150px" :rules="rules" :model="formData">
        <el-row :gutter="10">
          <el-col :span="12">
            <el-form-item label="风险分析单元名称" prop="unitName">
              <el-input
                v-model="formData.unitName"
                placeholder="请输入风险分析单元名称"
                maxlength="50"
                show-word-limit
                clearable
                :disabled="formProps.pageType === 'read'"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="风险分析单元编号" prop="unitNumber">
              <el-input
                v-model="formData.unitNumber"
                placeholder="请输入风险分析单元编号"
                maxlength="50"
                show-word-limit
                clearable
                :disabled="formProps.pageType === 'read'"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="风险分析单元类型" prop="unitType">
              <el-select
                v-model="formData.unitType"
                class="w-full"
                placeholder="请选择风险分析单元类型"
                filterable
                clearable
                :disabled="formProps.pageType === 'read'"
              >
                <el-option
                  v-for="item in riskAnalyssisUnitTypeList"
                  :key="item.code"
                  :label="item.displayName"
                  :value="Number(item.code)"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="是否构成重大危险源" prop="isMajorDangerSource">
              <el-radio-group
                :disabled="formProps.pageType === 'read'"
                size="small"
                v-model="formData.isMajorDangerSource"
                @input="inputChange"
              >
                <el-radio :label="true">是</el-radio>
                <el-radio :label="false">否</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="重大危险源名称" prop="significantHazardName">
              <el-input
                v-model="formData.significantHazardName"
                placeholder="请输入重大危险源名称"
                maxlength="50"
                show-word-limit
                clearable
                :disabled="formProps.pageType === 'read' || !formData.isMajorDangerSource"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="重大危险源编码" prop="significantHazardCode">
              <el-input
                v-model="formData.significantHazardCode"
                placeholder="请输入重大危险源编码"
                maxlength="50"
                show-word-limit
                clearable
                :disabled="formProps.pageType === 'read' || !formData.isMajorDangerSource"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="可能导致的事故类型" prop="mayAccidentTypeList">
              <el-select
                v-model="formData.mayAccidentTypeList"
                class="w-full"
                placeholder="请选择可能导致的事故类型"
                clearable
                filterable
                multiple
                collapse-tags
                :disabled="formProps.pageType === 'read'"
              >
                <el-option
                  v-for="item in accidentTypeList"
                  :key="item.code"
                  :label="item.displayName"
                  :value="Number(item.code)"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="区域位置" prop="regionalLocation">
              <el-select
                v-model="formData.regionalLocation"
                class="w-full"
                placeholder="请选择区域位置"
                clearable
                filterable
                :disabled="formProps.pageType === 'read'"
              >
                <el-option
                  v-for="item in areaList"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="所属单位" prop="affiliationOrg">
              <department-select
                v-model="formData.affiliationOrg"
                :disabled="formProps.pageType === 'read'"
              ></department-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="责任部门" prop="responsibleDepartment">
              <department-select
                v-model="formData.responsibleDepartment"
                @change="changeDepartment"
                :disabled="formProps.pageType === 'read'"
              ></department-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="责任人" prop="responsiblePerson">
              <el-select
                v-model="formData.responsiblePerson"
                class="w-full"
                placeholder="请选择责任人"
                clearable
                filterable
                :disabled="formProps.pageType === 'read'"
              >
                <el-option
                  v-for="item in userList"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="风险矫正因素" prop="riskCorrectiveFactors">
              <el-select
                v-model="formData.riskCorrectiveFactors"
                class="w-full"
                placeholder="请选择风险矫正因素"
                clearable
                filterable
                :disabled="formProps.pageType === 'read'"
              >
                <el-option
                  v-for="item in riskFactorsList"
                  :key="item.code"
                  :label="item.displayName"
                  :value="Number(item.code)"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="地面坐标" prop="groundCoordinates">
              <el-input
                v-model="formData.groundCoordinates"
                placeholder="例子：【119.1, 32.1】"
                maxlength="50"
                show-word-limit
                clearable
                :disabled="formProps.pageType === 'read'"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="备注" prop="remark">
              <el-input
                type="textarea"
                :rows="2"
                v-model="formData.remark"
                placeholder="请输入备注"
                clearable
                maxlength="5000"
                show-word-limit
                :disabled="formProps.pageType === 'read'"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </div>
    <div slot="footer" class="dialog-footer" v-if="formProps.pageType !== 'read'">
      <div class="flex justify-center">
        <el-button type="primary" size="small" @click="submitForm" :loading="loading"
          >保存</el-button
        >
        <el-button @click="closeDialog" size="small">取消</el-button>
      </div>
    </div>
  </el-dialog>
</template>

<script>
import { AreaApi } from '@wiz-api/area-management'
import { EafOrganizationUnitUserApi } from '@wiz-api/account'
import utils from '@/components/safety/enumField/utils'
import { RiskAnalysisUnitApi } from '@wiz-api/double-prevention-management'
import DepartmentSelect from '@/components/safety/DepartmentSelect/DepartmentSelect'

const areaApi = new AreaApi()
const riskAnalysisUnitApi = new RiskAnalysisUnitApi()
const eafOrganizationUnitUserApi = new EafOrganizationUnitUserApi()
export default {
  name: 'equip-unit-form',
  components: {
    DepartmentSelect,
  },
  props: {
    FormData: {
      type: Object,
      default: () => {},
    },
    /**
     * @description: 上传传递的参数
     * @param {控制弹窗显示隐藏} visible
     * @return {*}
     */
    formProps: {
      type: Object,
      default: () => {
        return {
          // create 新增 update 编辑 read 详情
          pageType: 'create',
        }
      },
    },
  },
  data() {
    return {
      visible: true,
      loading: false,
      formData: {},
      rules: {
        unitName: [
          { required: true, message: '请输入风险分析单元名称', trigger: ['blur', 'change'] },
        ],
        isMajorDangerSource: [
          { required: true, message: '请选择是否构成重大风险源', trigger: ['blur', 'change'] },
        ],
        responsibleDepartment: [
          { required: true, message: '请选择责任部门', trigger: ['blur', 'change'] },
        ],
        responsiblePerson: [
          { required: true, message: '请选择责任人', trigger: ['blur', 'change'] },
        ],
        affiliationOrg: [
          { required: true, message: '请选择所属单元', trigger: ['blur', 'change'] },
        ],
      },
      riskAnalyssisUnitTypeList: [],
      accidentTypeList: [],
      contractList: [],
      userList: [],
      areaList: [],
      riskFactorsList: [],
    }
  },
  created() {
    // 获取字典
    utils.getDataCategory(
      [
        'DoublePreventionManagement.DataCategory.RiskAnalyssisUnitType',
        'DoublePreventionManagement.DataCategory.AccidentType',
        'DoublePreventionManagement.DataCategory.RiskCorrectionFactor',
      ],
      ['riskAnalyssisUnitTypeList', 'accidentTypeList', 'riskFactorsList'],
      this
    )
    // 获取区域列表
    this.getAreaList()
    // 获取责任人
    if (this.formData.responsibleDepartment) {
      this.getUserList()
    } else {
      this.formData.responsiblePerson = undefined
      this.userList = []
    }
  },
  watch: {
    FormData: {
      handler(newVal, oldVal) {
        this.formData = newVal
        this.$nextTick(() => {
          this.$refs.form.clearValidate()
        })
      },
      immediate: true,
    },
  },
  methods: {
    // 切换责任部门
    changeDepartment(val) {
      if (val) {
        this.getUserList()
      } else {
        this.formData.responsiblePerson = undefined
        this.userList = []
      }
    },
    // 获取用户列表
    async getUserList() {
      const [err, res] = await eafOrganizationUnitUserApi.getOrganizationUnitUserList({
        organizationUnitId: this.formData.responsibleDepartment,
        includeOrgChild: true, // 是否查询该部门子部门人员
        skipCount: 0,
        maxResultCount: 999,
      })
      if (!err) {
        this.userList = res.items
      }
    },
    // 获取区域列表
    async getAreaList() {
      const [err, res] = await areaApi.getList({
        skipCount: 0,
        maxResultCount: 999,
      })
      if (!err) {
        this.areaList = res.items || []
      }
    },
    // radio选择事件
    inputChange(value) {
      if (!value) {
        this.formData.significantHazardName = ''
        this.formData.significantHazardCode = ''
      }
    },
    // 表单提交
    async submitForm() {
      this.$refs.form.validate(async (valid) => {
        if (valid) {
          if (this.formData.mayAccidentTypeList && this.formData.mayAccidentTypeList.length > 0) {
            this.formData.mayAccidentType = this.formData.mayAccidentTypeList.join(',')
          } else {
            this.formData.mayAccidentType = ''
          }
          this.loading = true
          this.formData = utils.deleteFormField(this.formData)
          if (this.formProps.pageType === 'create') {
            const [err, res] = await riskAnalysisUnitApi.create({ body: this.formData })
            if (!err) {
              this.$emit('refreshList')
              this.$message({
                showClose: true,
                message: '新增成功',
                type: 'success',
              })
            }
          } else {
            const [err, res] = await riskAnalysisUnitApi.update(this.formData.id, {
              body: this.formData,
            })
            if (!err) {
              this.$emit('refreshList')
              this.$message({
                showClose: true,
                message: '编辑成功',
                type: 'success',
              })
            }
          }
          this.loading = false
        }
      })
    },
    // 关闭弹窗
    closeDialog() {
      this.$emit('cancel')
    },
  },
}
</script>

<style scoped lang="scss"></style>
